import { merge } from 'ramda';

import {
  LOAD_PROJECTS_LIST_REQUEST, LOAD_PROJECTS_LIST_SUCCESS, LOAD_PROJECTS_LIST_FAIL,
  CREATE_PROJECT_REQUEST, CREATE_PROJECT_SUCCESS, CREATE_PROJECT_FAIL,
  UPDATE_PROJECT_REQUEST, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAIL,
  DELETE_PROJECT_REQUEST, DELETE_PROJECT_SUCCESS, DELETE_PROJECT_FAIL,
  UPDATE_PROJECT_USERS_REQUEST, UPDATE_PROJECT_USERS_SUCCESS, UPDATE_PROJECT_USERS_FAIL,
  UPDATE_PROJECT_JOBS_REQUEST, UPDATE_PROJECT_JOBS_SUCCESS, UPDATE_PROJECT_JOBS_FAIL,
  DELETE_PROJECT_USERS_REQUEST, DELETE_PROJECT_USERS_SUCCESS, DELETE_PROJECT_USERS_FAIL,
  DELETE_PROJECT_JOBS_REQUEST, DELETE_PROJECT_JOBS_SUCCESS, DELETE_PROJECT_JOBS_FAIL,
  LOAD_PROJECT_REQUEST, LOAD_PROJECT_SUCCESS, LOAD_PROJECT_FAIL,
  SET_CURRENT_PROJECT_ID, RESET_CURRENT_PROJECT
} from 'src/store/actions/projectsActions';

const initialState = {
  list: [],
  parsedList: [],
  options: [],
  loadFetching: false,
  createFetching: false,
  updateFetching: false,
  deleteFetching: false,
  associationsJobsFetching: false,
  associationsUsersFetching: false,
  associationsJobsDeleteFetching: false,
  associationsUsersDeleteFetching: false,
  currentProjectId: 0,
  currentProject: {},
  currentProjectFetching: false
};

const updateProject = (list, project) => list.map((listProject) => {
  if (listProject.Id !== project.Id) {
    return listProject;
  } else {
    return ({
      ...listProject,
      ...project
    });
  }
});

const deleteProject = (list, project) => list.filter((listProject) => listProject.Id !== project.Id);

const addAssociations = (list, { ProjectId, Associations }) => list.map((listProject) => {
  if (listProject.Id === ProjectId) {
    return ({
      ...listProject,
      Associations: [
        ...listProject.Associations,
        ...Associations
      ]
    });
  } else {
    return listProject;
  }
});

const deleteAssociations = (list, { ProjectId, ids, Type }) => list.map((listProject) => {
  if (listProject.Id === ProjectId) {
    return ({
      ...listProject,
      Associations: ids
        ? listProject.Associations.filter(({ Id }) => !ids.includes(Id))
        : listProject.Associations.filter(({ AssociationTypeId }) => AssociationTypeId !== Type)
    });
  } else {
    return listProject;
  }
});

const parseList = (list) => list.map((project) => ({
  ...project,
  Associations: project.Associations.reduce((counter, { AssociationTypeId, ValueId }) => {
    switch (AssociationTypeId) {
      case 'job': {
        counter.jobs.push(ValueId);
        return counter;
      }
      case 'user': {
        counter.users.push(ValueId);
        return counter;
      }
      default: return counter;
    }
  }, { jobs: [], users: [] })
}));

const getOptions = (list) => list.map(({ Id, Name }) => ({ label: Name, value: Id }));

const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_CURRENT_PROJECT:
      return merge(state, { currentProjectId: 0, currentProject: {} });
    case SET_CURRENT_PROJECT_ID:
      return merge(state, { currentProjectId: action.id });
    case LOAD_PROJECT_REQUEST:
      return merge(state, { currentProjectFetching: true });
    case LOAD_PROJECT_SUCCESS:
      return merge(state, { currentProjectFetching: false, currentProject: action.project });
    case LOAD_PROJECT_FAIL:
      return merge(state, { currentProjectFetching: false });
    case LOAD_PROJECTS_LIST_REQUEST:
      return merge(state, { loadFetching: true });
    case LOAD_PROJECTS_LIST_SUCCESS:
      return merge(state, {
        loadFetching: false,
        list: action.list,
        parsedList: parseList(action.list),
        options: getOptions(action.list)
      });
    case LOAD_PROJECTS_LIST_FAIL:
      return merge(state, { loadFetching: false });
    case CREATE_PROJECT_REQUEST:
      return merge(state, { createFetching: true });
    case CREATE_PROJECT_SUCCESS: {
      const newList = [...state.list, action.project];
      return merge(state, {
        createFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: action.project,
        currentProjectId: action.project.Id ? action.project.Id : 0
      });
    }
    case CREATE_PROJECT_FAIL:
      return merge(state, { createFetching: false });
    case UPDATE_PROJECT_REQUEST:
      return merge(state, { updateFetching: true });
    case UPDATE_PROJECT_SUCCESS: {
      const newList = updateProject(state.list, action.project);
      return merge(state, {
        updateFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {
          ...state.currentProject,
          ...action.project
        }
      });
    }
    case UPDATE_PROJECT_FAIL:
      return merge(state, { updateFetching: false });
    case DELETE_PROJECT_REQUEST:
      return merge(state, { deleteFetching: true });
    case DELETE_PROJECT_SUCCESS: {
      const newList = deleteProject(state.list, action.project);
      return merge(state, {
        deleteFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {},
        currentProjectId: 0
      });
    }
    case DELETE_PROJECT_FAIL:
      return merge(state, { deleteFetching: false });
    case UPDATE_PROJECT_USERS_REQUEST:
      return merge(state, { associationsUsersFetching: true });
    case UPDATE_PROJECT_USERS_SUCCESS: {
      const newList = addAssociations(state.list, action.associations);
      return merge(state, {
        associationsUsersFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {
          ...state.currentProject,
          Associations: [...state.currentProject.Associations, ...action.associations.Associations]
        }
      });
    }
    case UPDATE_PROJECT_USERS_FAIL:
      return merge(state, { associationsUsersFetching: false });
    case UPDATE_PROJECT_JOBS_REQUEST:
      return merge(state, { associationsJobsFetching: true });
    case UPDATE_PROJECT_JOBS_SUCCESS: {
      const newList = addAssociations(state.list, action.associations);
      return merge(state, {
        associationsJobsFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {
          ...state.currentProject,
          Associations: [...state.currentProject.Associations, ...action.associations.Associations]
        }
      });
    }
    case UPDATE_PROJECT_JOBS_FAIL:
      return merge(state, { associationsJobsFetching: false });
    case DELETE_PROJECT_USERS_REQUEST:
      return merge(state, { associationsUsersDeleteFetching: true });
    case DELETE_PROJECT_USERS_SUCCESS: {
      const newList = deleteAssociations(state.list, action.associations);
      return merge(state, {
        associationsUsersDeleteFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {
          ...state.currentProject,
          Associations: action.associations.ids
            ? state.currentProject.Associations.filter(({ Id }) => !action.associations.ids.includes(Id))
            : state.currentProject.Associations.filter(({ AssociationTypeId }) => AssociationTypeId !== action.associations.Type)
        }
      });
    }
    case DELETE_PROJECT_USERS_FAIL:
      return merge(state, { associationsUsersDeleteFetching: false });
    case DELETE_PROJECT_JOBS_REQUEST:
      return merge(state, { associationsJobsDeleteFetching: true });
    case DELETE_PROJECT_JOBS_SUCCESS: {
      const newList = deleteAssociations(state.list, action.associations);
      return merge(state, {
        associationsJobsDeleteFetching: false,
        list: newList,
        parsedList: parseList(newList),
        options: getOptions(newList),
        currentProject: {
          ...state.currentProject,
          Associations: action.associations.ids
            ? state.currentProject.Associations.filter(({ Id }) => !action.associations.ids.includes(Id))
            : state.currentProject.Associations.filter(({ AssociationTypeId }) => AssociationTypeId !== action.associations.Type)
        }
      });
    }
    case DELETE_PROJECT_JOBS_FAIL:
      return merge(state, { associationsJobsDeleteFetching: false });
    default: return state;
  }
};

export default projectsReducer;
